<div class="login-container">
  <div class="login-background">
    <div class="background-overlay"></div>
  </div>

  <div class="login-card">
    <div class="login-header">
      <div class="logo-container">
        <div class="logo-placeholder">
          <img src="assets/portal/images/stem/logo-white.png" alt="STEM Logo" class="stem-logo" />
        </div>
      </div>
      <ng-container *ngIf="!sent">
        <h1 class="login-title">Forgot Username</h1>
        <p class="login-subtitle">Enter your email address and we'll send you your username</p>
      </ng-container>
    </div>

    <div class="login-form-container">

      <!-- Request form -->
      <div *ngIf="!sent">
        <form [formGroup]="forgotUsernameForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="form-field">
            <label for="email" class="field-label">
              <i class="pi pi-envelope field-icon"></i>
              Email Address
            </label>
            <div class="input-container">
              <input
                id="email"
                type="email"
                formControlName="email"
                class="form-input"
                [class.input-error]="isFieldInvalid('email')"
                placeholder="Enter your email address"
                autocomplete="email"
                (input)="clearError()"
                [attr.aria-describedby]="isFieldInvalid('email') ? 'email-error' : null"
                [attr.aria-invalid]="isFieldInvalid('email')"
              />
              <i class="pi pi-envelope input-icon"></i>
            </div>
            <div
              *ngIf="isFieldInvalid('email')"
              class="error-message"
              id="email-error"
              role="alert"
            >
              <i class="pi pi-exclamation-triangle"></i>
              <span>{{ getFieldError('email') }}</span>
            </div>
          </div>

          <button
            type="submit"
            class="login-button"
            [disabled]="loading || forgotUsernameForm.invalid"
            [class.loading]="loading"
          >
            <span *ngIf="!loading" class="button-content">
              <i class="pi pi-send"></i>
              Send My Username
            </span>
            <span *ngIf="loading" class="button-content">
              <i class="pi pi-spin pi-spinner"></i>
              Sending...
            </span>
          </button>

          <div *ngIf="error" class="error-alert" role="alert" aria-live="polite">
            <i class="pi pi-exclamation-circle"></i>
            <span>{{ error }}</span>
          </div>
        </form>

        <div class="back-to-login">
          <a class="back-link" [routerLink]="['/login']" tabindex="0">
            <i class="pi pi-arrow-left"></i>
            Back to Login
          </a>
        </div>
      </div>

      <!-- Success state -->
      <div *ngIf="sent" class="success-message">
        <div class="success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h2 class="success-title">Username Sent</h2>
        <p class="success-text">
          If an account exists for that email address, we've sent your username to your inbox.
          Please check your email and use your username to sign in.
        </p>
        <div class="back-to-login">
          <a class="back-link" [routerLink]="['/login']" tabindex="0">
            <i class="pi pi-sign-in"></i>
            Go to Login
          </a>
        </div>
      </div>

    </div>
  </div>
</div>
